import { FC } from "react";

import { Navigate, Route, Routes } from "react-router-dom";

import DashboardPage from "./pages/DashboardPage";
import FeedbackListPage from "./pages/FeedbackListPage";
import SettingsPage from "./pages/SettingsPage";
import SurveyDetailPage from "./pages/SurveyDetailPage";
import SurveysPage from "./pages/SurveysPage";

// TODO: re-enable per-route permission gating once backend issues feedback.* perms.
// Original logic used a <PermissionGate> wrapping each route element with the
// matching canView*Feedback flag from userPermissionChecks().
const FeedbackApp: FC = () => (
  <Routes>
    <Route path="feedback" element={<FeedbackListPage />} />
    <Route path="surveys">
      <Route index element={<SurveysPage />} />
      <Route path=":collectionId" element={<SurveyDetailPage />} />
    </Route>
    <Route path="dashboard" element={<DashboardPage />} />
    <Route path="settings" element={<SettingsPage />} />
    <Route path="*" element={<Navigate to="feedback" replace />} />
  </Routes>
);

export default FeedbackApp;
